import React, { useEffect } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import Users from '../../Users';
import DateRange from '../../DateRange';
import { Link, useNavigate } from 'react-router';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Spinner } from 'reactstrap';
import useFilter from '../../../hooks/useFilter';
import useNavBar from '../../../hooks/useNavBar';
import WSRBCodes from '../../WSRBCodes';

export default function WSRBSummaryReportForm() {
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const users = Users();
    const wsrbCodes = WSRBCodes();
    const dateRange = DateRange();

    const { filter, setFilter } = useFilter();
    const { loading, setLoading } = useNavBar();


    const headers =
        [
            "Full name",
            "Email",
            "Department",
            "Personnel ID",
            "Rank",
            "Shift",
            "Station",
            "Division",
            "Battalion",
            "Company",
            "Platoon",
            "Bureau",
            "Total Hours",
            "13b. Company Training",
            "13c. Training Center Training",
            "13d. Officer Training",
            "13e. Driver & Operator Training",
            "13f. Recruits Training",
        ];

    useEffect(() => {
        if (!users.loading && !wsrbCodes.loading && !dateRange.loading) {
            setLoading(false);
        }

        const headersWithActive = users.includeInactiveUsers ? [...headers, "User Status"] : headers;

        setFilter({
            users: users.selectedUsers.map(user => user.value),
            groups: users.selectedGroups.map(group => group.value),
            WSRBCodes: wsrbCodes.selected.map(code => code.value),
            headers: headersWithActive,
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,

            selectAllUsers: users.selectAll,
            formUsers: users.users,
            formGroups: users.groups,
            includeInactiveUsers: users.includeInactiveUsers,
            formWSRBCodes: wsrbCodes.wsrbCodes
        });

        wsrbCodes.setAllowNullWSRBCodesOption(false);
    }, [users.loading,
    users.selectAll,
    users.selectedUsers,
    users.users,
    users.selectedGroups,
    users.groups,
    users.includeInactiveUsers,
    wsrbCodes.loading,
    wsrbCodes.selected,
    wsrbCodes.wsrbCodes,
    wsrbCodes.setAllowNullWSRBCodesOption,
    dateRange.loading,
    dateRange.startDate,
    dateRange.endDate]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendfilter = (
            (
                { users, groups, WSRBCodes, headers, startDate, endDate }) =>
                ({ users, groups, WSRBCodes, headers, startDate, endDate })
        )(filter);
        debugger
        try {
            await axiosPrivate.post('api/reports/wsrbsummary', sendfilter);
            navigate('/reports');
        }
        catch (err) {
            console.log(err);
        }
    }

    return (
        loading ? <Spinner variant="primary" animation="border" role="status" className='custom-spinner' /> :
            <Container>
                <Col>
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {users.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {wsrbCodes.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {dateRange.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                </Col>
                <footer>
                    <Form onSubmit={handleSubmit}>
                        <Button color="primary">Generate Report</Button>
                        <Link to="/">
                            <Button className='btn-danger'>Back</Button>
                        </Link>
                    </Form>
                </footer>
            </Container>
    );
}
